import PageTitle from "../../Utils/smsTitle";
import {SubHeader} from "../../../Containers/SubHeader";
import ObGynPatientInfo from "../Utils/ObGynPatientInfo";
import {bindActionCreators} from "redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import {connect} from "react-redux";
import React, {useEffect, useState} from "react";
import {
    Border,
    Heading
} from "../../DoctorsModule/PatientPreviousVisits";
import {PreviousGynVisits} from "../Utils/PreviousVisits";
import ObGynSidebar from "../Utils/ObGynSidebar";
import axios from "axios";
import {config} from "../../../Helpers/env";
import {logoutErrorMessage} from "../../../Helpers/ErrorMessages";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";



const GynAndObsHistory = ({ actions, match,snackbar }) => {

    const {patient_number, visit_id, patient_type} = match.params;

    // get the doctor's name
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const doctor_name = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;


    const tabs = [{value:'Triage', component:'triage',isActive:true},{value:' Clinical Notes', component:'notes'},
        {value:'Procedure', component:'procedure'},
        {value:'Laboratory', component:'lab'},{value:'Radiology', component:'radiology'},
        {value:'Diagnosis', component:'diagnosis'},{value:'Prescription', component:'prescription'}]

    const [visits, setVisits] = useState([]);

    function sortArr(arr=[]) {
        return arr.sort((a, b)=>new Date(b.begin_datetime) - new Date(a.begin_datetime))
    }


    useEffect(() => {
        if(!patient_number){
            return;
        }
        const formData = new FormData();
        formData.append('patient_number', patient_number);

        axios.post(`${config.smsUrl}/cpatient/get_patient_previous_visits`, formData).then(res => {
            const data = res.data;
            const visit = !data ? {} : data;
            const visitsArr = !visit.patient_visits ? [] : visit.patient_visits;
            const sortedArr = sortArr(visitsArr)
            const singleVisit = sortedArr[0] ? sortedArr[0] :{};
            const v_id = singleVisit.visit_id ? singleVisit.visit_id : ''
            const formData = new FormData();
            formData.append('visit_id', v_id);

            axios.post(`${config.smsUrl}/cdoctor/get_all_patient_treatment_details`, formData).then(res => {
                const data = res.data;
                const details = !data ? {} : data;
                const {lab_result,scan_result, diagnosis,prescription,other_medicine,exam_notes,triage,visit_detail} = details
                const presc = prescription ? prescription : [];
                const others = other_medicine ? other_medicine : [];
                const other_meds = others.filter(item=>Boolean(item));
                const medicationArr = [...presc, ...other_meds];
                const labArr = lab_result?.map(item=>({...item, open:true}))
                const scanArr = scan_result?.map(item=>({...item, open:true}))
                const procedure = details.procedure ? details.procedure : []
                const arr = sortedArr.map((item, index)=>({
                    ...item,components:tabs,activeItem:'triage', open: index === 0,
                    labResults : labArr,
                    radiologyResults : scanArr,
                    patientDiagnosis : diagnosis,
                    medication : medicationArr,
                    patientTriage : triage,
                    procedure,
                    clinicalNotes :  exam_notes.map(note=>({
                        ...note, openNote:true
                    })),
                }))
                setVisits(arr)
            }).catch(err => {
                logoutErrorMessage(err, null, actions)
            })
        }).catch(err => {
            logoutErrorMessage(err, null, actions)
        })

    }, [patient_number]);

    const closeSnackbar = () =>{
        actions.snackbarActions.hideSnackbar()
    };

    const {openBar, type, message} = snackbar;

    return (
        <div className="journals">
            <PageTitle title="Medical History"/>
            <SubHeader
                title="OB/GYN"
                subTitle="Medical History"
                doctor_name={doctor_name}
            >
                <div className="header-icon-margin-right-zero"><img src="/images/antenatal-blue.png"
                                                                    className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
            <ObGynSidebar
                patient_number={patient_number}
                visit_id={visit_id}
                patient_type={patient_type}
            >
                <div style={{padding: '12px 16px'}}>
                    <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} />
                    <Heading>Previous Visits</Heading>
                    <Border />
                    <PreviousGynVisits {...{visits, setVisits, actions}}/>
                </div>
            </ObGynSidebar>
        </div>
    );
};

function mapStateToProps(state) {
    const { snackbar } = state;
    return { snackbar };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GynAndObsHistory);